import React, {Component} from 'react';
import AddStackItem from './add-stack-item';
import {connect} from 'react-redux';
import StackItem from './stack-item';
import RemoveStackItem from './remove-stack-item';

class Settings extends Component {
    render() {
        const {stacking} = this.props;
        const competitionType = stacking.getCompetitionType();

        return (
            <div className="white-box">
                <h3>Create New Rule</h3>
                <div className="gray-holder">
                    {Object.keys(stacking.getItems()).map((itemId, index) => {
                        return (
                            <StackItem key={itemId} itemId={itemId} competitionType={competitionType}>
                                {index ? (
                                    <RemoveStackItem itemId={itemId}>
                                        <i className="fa fa-times-circle"></i>
                                    </RemoveStackItem>
                                ) : null}
                            </StackItem>
                        );
                    })}
                    <div className="add-rule">
                        <AddStackItem />
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {competitionStacking} = state;

    return {
        stacking: competitionStacking,
    };
}

export default connect(mapStatesToProps)(Settings);
